<template lang="pug">
  #ReservationEdit.container-width
    h5.text-center.py-3.letter-spacing-6 修改預約
    hr.border-primary.pb-3
    .content.customerInput
      ValidationObserver(
        ref="form"
        tag="form"
        @submit.stop.prevent="submitHandler"
      )
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValName"
          )
            b-form-input(
              id="name",
              type="text",
              required,
              trim,
              :state="validState('name')",
              v-model="form.name",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請輸入客戶姓名",
              :disabled="true"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValService",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.service",
              tag-placeholder="輸入搜尋預約服務",
              placeholder="請選擇預約服務",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="reserve_type_name",
              track-by="reserve_type_id"
              :options="reservationsTypeList",
              :allow-empty="false"
              noOptions="無預約服務"
            )
              template(slot="noOptions")
                strong 無預約服務
            div(
              id="input-name-live-feedback",
              v-show="form.service === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
            .pt-2(
              v-if="form.service && form.service.reserve_type_name === '珠寶保養'"
            )
              small.d-block.m-1.text-left 珠寶保養事前須知:
              small.d-block.m-1.text-left 需視實際評估作品後，可能有部分收費需求或更長工作天進行後續服務。
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValDate"
          )
            b-form-datepicker(
              id="date",
              type="date",
              required,
              trim,
              :state="validState('date')",
              v-model="form.date",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請選擇預約日期",
              :min="dateMinLimit",
              :max="dateMaxLimit",
              @input="getReservationTimeHandler()"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValTimeId"
          )
            multiselect(
              v-model="form.timeId",
              tag-placeholder="輸入搜尋預約時段",
              placeholder="請選擇預約時段",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="start_time",
              track-by="reserve_period_id"
              :custom-label="nameWithTimeId"
              :options="reservationTimeList",
              :allow-empty="false"
              noOptions="無預約時段"
            )
              template(slot="noOptions")
                strong 無預約時段
            div(
              id="input-name-live-feedback",
              v-show="form.timeId === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValJoinPeople",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.joinPeople",
              tag-placeholder="輸入搜尋參與人數",
              placeholder="請選擇參與人數",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="text",
              track-by="id"
              :options="joinPeopleOption",
              :allow-empty="false"
              noOptions="無參與人數"
            )
              template(slot="noOptions")
                strong 無參與人數
            div(
              id="input-name-live-feedback",
              v-show="form.joinPeople === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
      .row.no-gutters
        .col-6
          button.btn.btn-block.btn-primary.text-center.rounded-0(
            type="button",
            @click="$router.push({ name: 'sa-reservation-index' })"
          ) 取消
        .col-6
          button.btn.btn-block.btn-primary.text-center.rounded-0(
            type="button",
            @click="submitHandler()"
          ) 送出
</template>

<script>
import { mapState } from 'vuex';
import { SA_RESERVATION_INDEX } from '@/router/sa/reservation';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'ReservationEdit',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    editInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: null,
        service: null,
        date: null,
        timeId: null,
        joinPeople: null,
        store_id: null
      },
      joinPeopleOption: [],
      dateMinLimit: moment().add(3, 'days').format(),
      dateMaxLimit: moment().add(33, 'days').format()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        vm.$swal.showLoading();
      }
    });

    let reservationTimeListApiTarget;
        let reservationTypeApiTarget;

    if (vm.editInfo.created_by) {
      switch (vm.editInfo.created_by) {
        case 'USER':
          reservationTimeListApiTarget = 'getUnbindReservationTimeListHandler';
          reservationTypeApiTarget = 'getUnbindReservationTypesHandler';
          for (let i = 1; i <= 2; i++) {
            vm.joinPeopleOption.push({
              id: i, text: i.toString()
            });
          }
          break;
        case 'SP':
          reservationTimeListApiTarget = 'getReservationTimeListHandler';
          reservationTypeApiTarget = 'getReservationTypeListHandler';
          for (let i = 1; i <= 8; i++) {
            vm.joinPeopleOption.push({
              id: i, text: i.toString()
            });
          }
          break;
        default:
          break;
      }
    }

    if (!reservationTimeListApiTarget || !reservationTypeApiTarget) {
      vm.$swal.fire({
        icon: 'error',
        title: '預約編輯目標錯誤[Err: Not Has Created By]',
        showCancelButton: true,
        confirmButtonText: '確定',
        reverseButtons: false
      })
        .then(() => {
          vm.$router.push({ name: 'sa-reservation-index' });
        });
    } else {
      vm.$store.dispatch(`sa_reservation/${reservationTimeListApiTarget}`, {
        store_id: vm.editInfo.store_id,
        reserve_date: vm.editInfo.reserve_date,
        reserve_id: vm.editInfo.reservation_id // 更新時要帶預約id 這樣後端才能排除自己的預約(CA時段下拉)
      })
        .then(() => {
          const timeIdKey = _.findKey(vm.reservationTimeList, (val) => val.reserve_period_id === vm.editInfo.reservation_period_id);
          vm.form.timeId = vm.reservationTimeList[timeIdKey];
          vm.$swal.close();
        });

      // 取得預約服務選項
      vm.$store.dispatch(`sa_reservation/${reservationTypeApiTarget}`)
        .then(() => {
          // 塞回資料
          vm.form.name = vm.editInfo.line_name;
          const reservationsTypeListKey = _.findKey(vm.reservationsTypeList, (val) => val.reserve_type_id === vm.editInfo.reserve_type_id);
          vm.form.service = vm.reservationsTypeList[reservationsTypeListKey];
          vm.form.date = vm.editInfo.reserve_date;
          vm.form.store_id = vm.editInfo.store_id;
          const joinPeopleKey = _.findKey(vm.joinPeopleOption, (val) => val.id === vm.editInfo.companion_number);
          vm.form.joinPeople = vm.joinPeopleOption[joinPeopleKey];
          vm.$swal.close();
        });
    }
  },
  methods: {
    nameWithTimeId({ start_time, end_time, site }) {
      return `${start_time}~${end_time}(${site})`;
    },
    moment() {
      return moment();
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.name === null) {
          vm.form.name = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.joinPeople === null) {
          vm.form.joinPeople = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
              const now = moment().format('hh:mm');
              const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
              const endTime = moment(now, 'hh:mma');
              const today = moment().format('YYYY-MM-DD');
              const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

        if (moment(reservationDate).isBefore(today)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前日期'
          });
        } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前時間'
          });
        } else {
          vm.$swal.fire({
            title: '請稍候，\n表單送出中',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          const sendData = {
            reservation_id: vm.editInfo.reservation_id,
            reservation_type_id: vm.form.service.reserve_type_id,
            date: vm.form.date,
            companion_number: vm.form.joinPeople.id,
            reservation_period_id: vm.form.timeId.reserve_period_id
          };

          vm.$store.dispatch('sa_reservation/updateReservationHandler', sendData)
            .then(() => {
              vm.$swal.close();
              vm.$snotify.success(null, '修改成功');
              vm.$router.push({
                name: SA_RESERVATION_INDEX
              });
            });
        }
      }
    },
    getReservationTimeHandler() {
      const vm = this;
      if (vm.form.store_id && vm.form.date) {
        vm.$swal.fire({
          title: '請稍候，\n取得該店可預約時段中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_reservation/getReservationTimeListHandler', {
          store_id: vm.form.store_id,
          reserve_date: vm.form.date
        })
          .then((data) => {
            if (data.options.length === 0) {
              vm.form.timeId = '';
              vm.$swal.fire({
                icon: 'info',
                title: '請選擇其他預約日期、此日期無預約時段'
              }).then(() => {
                $('#date').click();
              });
            } else {
              vm.$swal.close();
            }
          });
      } else {
        vm.$store.commit('sa_reservation/resetReservationTimeListHandler');
        vm.form.timeId = null;
      }
    }
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.sa_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList
    })
  }
};
</script>

<style lang="scss" scoped>
.customerInput {
  * {
    text-align: center;
  }
  input,
  select,
  .b-form-btn-label-control,
  .itemRow {
    border-radius: 0;
    border: 0;
    border-top: 1px solid #e8e8e8!important;
    border-bottom: 1px solid #e8e8e8!important;
    background-color: #FCFBFB;
    text-align: center;
    text-align-last: center;
    height: 45px;
    padding-right: 0;
    span {
      width: 100%;
    }
  }
}

.multiselect__tags {
  border: none!important;
  height: 100%;
  padding-right: 0;
}
</style>
